import React, {Component} from 'react';
import Select from 'react-select';
import PropTypes from "prop-types";
import Machines from "../utils/entities/Machines";
import StaticFunctions from "../utils/StaticFunctions";


class MachineSelector extends Component {

    static propTypes = {
        machine: PropTypes.instanceOf(Machines).isRequired,
        onMachineSelected: PropTypes.func.isRequired,
    };

    static defaultProps = {
        classes: '',
        currentMachine: null,
        currentLocation: null,
        addAllOption: false,
    };

    constructor(props) {

        super(props);

        this.translate = this.props.translate;

        this.state = {
            currentMachine: (this.props.addAllOption) ? 'all' : null
            //currentMachine: (props.addAllOption) ? {value: 'all', label: this.translate('all')} : null
        };

        this.selectMachine = this.selectMachine.bind(this);

    }

    componentDidMount() {

        // Maschine aus parent setzen
        if (this.props.currentMachine) {
            this.setState({
                currentMachine: this.props.currentMachine
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        this.checkForValidSelection(this.props);

    }

    checkForValidSelection(nextProps) {

        const currentMachine = this.state.currentMachine;

        if (currentMachine && nextProps) {
            let nextMachineId = [];
            if (nextProps.currentCompany !== undefined) {
                const machines = nextProps.machine ? nextProps.machine.getMachinesByCompanyId(nextProps.currentCompany) : [];
                nextMachineId = machines.map(m => String(m.machine_id));
            } else {
                nextMachineId = nextProps.machine.getAllMachineIdsFromLocation(nextProps.currentLocation);
            }

            const currentDefault = (this.props.addAllOption) ? 'all' : null;    //  {value: 'all', label: this.translate('all')} : null

            if (this.state.currentMachine !== currentDefault && (nextProps.currentLocation !== null || nextProps.currentCompany !== undefined) && currentMachine.value !== 'all' && !nextMachineId.includes(currentMachine.value)) {
                this.setState({
                    currentMachine: currentDefault
                });
            }
        }

    }

    selectMachine(machine) {

        this.setState({
            currentMachine: machine
        });

        if (this.props.onMachineSelected) this.props.onMachineSelected(machine)

    }

    getOptions() {

        let machines = [];

        if (this.props.currentCompany !== undefined) {
            machines = this.props.machine ? this.props.machine.getMachinesByCompanyId(this.props.currentCompany) : [];
        } else if (this.props.currentLocation !== null) {
            machines = this.props.machine ? this.props.machine.getMachinesByLocationId(this.props.currentLocation) : [];
        } else {
            machines = this.props.machine ? this.props.machine.getAllMachines('name', 'asc') : [];
        }

        const sortedMachines = StaticFunctions.getSortedData(machines, 'alias', 'string');
        const opt = [];

        if (this.props.addAllOption)  {
            opt.push({
                value: 'all',
                label: this.translate('all')
            })
        }

        for (let ix in sortedMachines) {
            let machine = sortedMachines[ix];

            opt.push({
                value: String(machine.machine_id),
                label: machine.getLabel ? machine.getLabel() : machine.alias ? machine.alias : machine.machine_id
            })
        }

        return opt;

    }

    getSelecedOption() {

        const currentMachineData = (this.props.machine && this.state.currentMachine) ? this.props.machine.getMachineByMachineId(this.state.currentMachine.value) : null;

        let selectedOption = null;

        if (typeof currentMachineData !== 'undefined' && currentMachineData !== null) {
            selectedOption = this.state.currentMachine;
        } else if (this.props.addAllOption) {
            selectedOption = 'all';
        }

        return selectedOption;

    }

    render() {

        const classes = ['chosen-container', 'chosen-container-single', this.props.classes].join(' ').trim();
        const opts = this.getOptions();
        const selectedMachine = this.getSelecedOption();

        return (
            <Select
                name="form-field-name"
                className={classes}
                options={opts}
                onChange={this.selectMachine}
                value={selectedMachine}
                placeholder={this.translate('select') + '...'}
                clearable={false}
                noResultsText={this.translate('noResultsFound')}
                multi={false}
            />
        );

    }

}

export default MachineSelector;